/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import Login from './Login';
import ActionConfirmation from 'components/common/ActionConfirmation';
import { ROUTE_PATHS } from 'routes/constants';
import { clearLocalStorage } from 'services/authUtils';

const LoginStages = ({ authStore }) => {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      if (authStore.isLoginSuccess && location.pathname === ROUTE_PATHS.LOGIN) {
        authStore.reset();
        clearLocalStorage();
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleSetPhone = (phone) => authStore.setPhone(phone);

  const handleSetUsername = (username) => authStore.setUsername(username);

  const handleSetPassword = (password) => authStore.setPassword(password);

  const handleSendAuthorizationData = async () => await authStore.sendAuthorizationData();

  return (
    <div>
      {authStore.isLoginSuccess ? (
        <ActionConfirmation />
      ) : (
        <Login
          phone={authStore.values.phone}
          password={authStore.values.password}
          setPhone={handleSetPhone}
          setUsername={handleSetUsername}
          setPassword={handleSetPassword}
          sendAuthorizationData={handleSendAuthorizationData}
          error={authStore.error}
          isLoading={authStore.isLoading}
        />
      )}
    </div>
  );
};

LoginStages.propTypes = {
  authStore: MobXPropTypes.observableObject
};

export default inject('authStore')(observer(LoginStages));
